<button
  type="button"
  class="scv2-toggle"
  [class.scv2-on]="checked"
  [class.scv2-disabled]="disabled"
  [disabled]="disabled"
  (click)="toggle()"
>
  <span class="scv2-toggle-knob" [class.scv2-on]="checked"></span>
</button>
